export const REQUEST_SOCIALNETWORK = 'REQUEST_SOCIALNETWORK';
export const RECEIVE_SOCIALNETWORK = 'RECEIVE_SOCIALNETWORK';
export const UPDATE_SOCIALNETWORK_ITEM = 'UPDATE_SOCIALNETWORK_ITEM';
export const HANDLE_SOCIAL_ERROR = 'HANDLE_SOCIAL_ERROR';

export const UNFOLLOW_CODE = 0;
export const FOLLOW_REQUEST_CODE = 1;
export const FOLLOW_CODE = 2;
export const BLOCK_CODE = 3;